// ABOUTME: Wire contracts for api's /me/preferences routes: the stored user preferences,
// ABOUTME: their partial patch body, the defaults, and the GET response shape

import { z } from 'zod';

export const UserPreferencesSchema = z.object({
  displayCurrency: z.enum(['USD', 'EUR', 'GBP', 'CAD', 'AUD', 'JPY', 'CHF']),
  defaultLandingPath: z.enum(['/', '/discovery', '/portfolio', '/symbols', '/watchlist']),
  defaultBenchmarkSymbol: z.string().min(1).max(20).nullable(),
  defaultChartRange: z.enum(['1M', '3M', '1Y', '5Y']),
  pinnedPortfolioId: z.string().min(1).nullable(),
  pinnedWatchlistId: z.string().min(1).nullable(),
  confirmTrades: z.boolean(),
  positionSizingRule: z.enum(['FIXED_USD', 'FIXED_PCT', 'KELLY']),
  positionSizingValue: z.number().positive().max(1_000_000),
  riskProfile: z.enum(['conservative', 'balanced', 'aggressive']),
});
export type UserPreferences = z.infer<typeof UserPreferencesSchema>;

export const PatchUserPreferencesSchema = UserPreferencesSchema.partial();

export const PREF_DEFAULTS: UserPreferences = {
  displayCurrency: 'USD',
  defaultLandingPath: '/',
  defaultBenchmarkSymbol: null,
  defaultChartRange: '1Y',
  pinnedPortfolioId: null,
  pinnedWatchlistId: null,
  confirmTrades: true,
  positionSizingRule: 'FIXED_PCT',
  positionSizingValue: 0.05,
  riskProfile: 'balanced',
};

export const MePreferencesSchema = UserPreferencesSchema.extend({
  defaultPortfolioId: z.string().nullable(),
});
export type MePreferences = z.infer<typeof MePreferencesSchema>;
